import { observer } from '@formily/reactive-vue';
import { isVoidField } from '@formily/core';
import { connect, mapProps, mapReadPretty, h, useField } from '@formily/vue';
import { defineComponent, ref, h as vueH, onMounted, onUpdated } from '@vue/composition-api';
import { Field as VanInput, Cell } from 'vant';
import { transformComponent, resolveComponent } from '@formily/vant/esm/__builtins__/shared';
import { PreviewText } from '@formily/vant';
import store from '../../store';
// @ts-ignore
import VoiceInput from './VoiceInput.vue';
// @ts-ignore
import ImageUploadInput from './ImageUploadInput.vue';

const stylePrefix = 'formily-vant';

const TransformVanInput = transformComponent(VanInput, {
  change: 'input',
});

export const BaseInput = observer(
  defineComponent({
    name: 'FBaseInput',
    setup(props, { attrs, listeners, slots }) {
      const id = Math.random().toString(36).slice(5);
      const field = useField();
      const startStr = ref('');
      const isInArrayTable = ref(false);
      // const inputRef = ref(null); // 添加输入框引用
      let voiceVisible = false;

      // 设计器“容器样式”字体颜色：vant 输入元素自身有显式色值（会挡住外层继承），
      // 这里把设计器配置的颜色（组件样式或表单项容器样式）直接内联到内部输入元素。
      // 用 lastAppliedColor 做缓存：多数输入框没有颜色配置，每次 updated 直接短路返回，
      // 只有颜色值变化时才做一次 DOM 查询与写入。
      let lastAppliedColor;
      const applyContainerColor = () => {
        try {
          const f = field.value;
          if (!f) return;
          const compStyle = (f.componentProps && f.componentProps.style) || {};
          const decStyle = ((f.decoratorProps || {}).style) || {};
          const color = compStyle.color || decStyle.color;
          if (color === lastAppliedColor) return;
          const root = document.getElementById(id);
          if (!root) return;
          let inputEl = root.querySelector('textarea, input');
          if (!inputEl && (root.tagName === 'TEXTAREA' || root.tagName === 'INPUT')) {
            inputEl = root;
          }
          if (!inputEl) return;
          // 只设置/清空颜色，避免影响其他样式
          inputEl.style.color = color ? String(color) : '';
          lastAppliedColor = color;
        } catch (e) {
          // 忽略异常，不影响输入框正常渲染
        }
      };
      onMounted(() => {
        setTimeout(applyContainerColor, 0);
      });
      onUpdated(applyContainerColor);

      // 检测是否在 array table 中（通过 parent 向上遍历）
      try {
        let parent = field.value?.parent;
        while (parent) {
          const comp = parent.component;
          const compName = Array.isArray(comp) ? comp[0] : (typeof comp === 'string' ? comp : '');
          if (compName === 'ArrayTable' || compName === 'NewArrayTable') {
            isInArrayTable.value = true;
            break;
          }
          parent = parent.parent;
        }
      } catch (e) {
        // ignore
      }

      try {
        const users = JSON.parse(store.getters.getConfigItem('cpnShowVoice'));
        if (users?.includes?.(sessionStorage.getItem('userid'))) {
          voiceVisible = true
        }
        if (users?.length === 0) {
          voiceVisible = true
        }
      } catch (e) {
      }

      return () => {
        // 创建新的slots对象，保留原有slots并添加extra
        const newSlots = { ...slots };

        // 处理extra slot
        const originalExtra = slots.extra;
        newSlots.extra = () => {
          const extraContent = [];

          // 先添加原有的 addonAfter
          if (field.value.decoratorProps.addonAfter) {
            extraContent.push(field.value.decoratorProps.addonAfter);
          }

          // 如果原来有extra slot，也添加进来
          // console.log('originalExtra==>',slots.extra,slots);

          if (originalExtra) {
            const originalContent = originalExtra();
            if (Array.isArray(originalContent)) {
              extraContent.push(...originalContent);
            } else if (originalContent) {
              extraContent.push(originalContent);
            }
          }

          // 最后添加语音输入图标（仅在非禁用、非只读、非TextArea时显示）
          if (
            voiceVisible &&
            field.value.pattern === 'editable'
          ) {
            // 在语音按钮左侧添加图片上传按钮
            const _$context = field.value.form?.values?.$context || {};
            const _explicitProp = field.value.componentProps.enableImageUpload;
            // 当 enableImageUpload 被显式设置为 false 时，直接关闭OCR，优先级最高
            let _enableOcr = false;
            if (_explicitProp === false) {
              _enableOcr = false;
            } else {
              let _photoServiceMatch = false;
              let _photoKeyMatch = false;
              try {
                const photoServiceList = JSON.parse(store.getters.getConfigItem('photoServiceList'));
                if (Array.isArray(photoServiceList) && photoServiceList.includes(_$context.service_name)) {
                  _photoServiceMatch = true;
                }
              } catch (e) { }
              try {
                const photoKeyList = JSON.parse(store.getters.getConfigItem('photoKeyList'));
                if (Array.isArray(photoKeyList)) {
                  if (photoKeyList.length === 0 || photoKeyList.includes(_$context.ProcessDefinitionKey)) {
                    _photoKeyMatch = true;
                  }
                }
              } catch (e) { }
              let _photoFieldBlocked = false;
              try {
                const photoFieldBlacklist = JSON.parse(store.getters.getConfigItem('photoFieldBlacklist'));
                const _fieldPath = field.value.path?.toString() || '';
                if (Array.isArray(photoFieldBlacklist) && photoFieldBlacklist.includes(_$context.ProcessDefinitionKey)) {
                  _photoFieldBlocked = true;
                }
              } catch (e) { }
              _enableOcr = !_photoFieldBlocked && (_explicitProp || _photoServiceMatch || _photoKeyMatch);
            }
            if (_enableOcr) {
              extraContent.push(
                // @ts-ignore
                h(ImageUploadInput, {
                  props: {
                    value: field.value.value,
                    fieldName: field.value.path?.toString() || '',
                    fieldTitle: field.value.title || '',
                    action: field.value.componentProps.imageUploadAction || '/relay/cosfile/index',
                    newChooseImage: field.value.componentProps.newChooseImage || false,
                    ocrCallback: field.value.componentProps.ocrCallback || null,
                    extraPrompt: field.value.componentProps.extraPrompt || '',
                    processDefinitionKey: field.value.form?.values?.$context?.ProcessDefinitionKey || '',
                  },
                  on: {
                    'ocr-text-selected': (text) => {
                      // OCR识别的文字追加到输入框内容中
                      const currentValue = field.value.value || '';
                      const newValue = currentValue ? `${currentValue} ${text}` : text;
                      if (listeners.change) {
                        listeners.change(newValue);
                      }
                    },
                  },
                }, {
                  default: () => [],
                })
              );
            }

            extraContent.push(
              // @ts-ignore
              h(VoiceInput, {
                props: {
                  value: field.value.value,
                  componentType: 'Input',
                  fieldName: field.value.path?.toString() || '',
                  fieldTitle: field.value.title || '',
                },
                on: {
                  // input: (val: string) => {
                  //   field.value.setValue(val || '');
                  // },
                  start: () => {
                    startStr.value = field.value.value || '';
                    const inputRef = document.getElementById(id);
                    // 聚焦到输入框
                    if (inputRef) {
                      // 使用 nextTick 确保 DOM 已更新
                      setTimeout(() => {
                        try {
                          // 尝试获取 vant Field 组件的输入框元素
                          const inputElement = inputRef?.querySelector('input') ||
                            inputRef?.querySelector('textarea');
                          if (inputElement && typeof inputElement.focus === 'function') {
                            inputElement.focus();
                            // console.log('[Input] 语音输入开始，已聚焦到输入框');
                          }
                          console.log(inputElement, inputRef.value.$el)
                        } catch (error) {
                          // console.error('[Input] 聚焦输入框失败:', error);
                        }
                      }, 100);
                    }
                  },
                  change: (val) => {
                    if (listeners.change) {
                      // console.log(startStr.value, 22222)
                      listeners.change(startStr.value + val || '');
                    }
                  },
                },
              }, {
                default: () => [],
              })
            );
          }

          // 有 description 时，根据是否在数组表格中执行不同的逻辑
          // 在数组表格中：在 extra 中添加 description
          // 不在数组表格中：使用 newSlots.label 显示 description
          try {
            // 读取配置并解析为 JSON 格式
            const configStr = store.getters.getConfigItem('inputDescFix');
            let inputDescFixEnabled = false;

            if (configStr) {
              try {
                const config = JSON.parse(configStr);

                // 判断 open 的值
                const isOpen = config.open === true;

                if (!isOpen) {
                  // open 为 false 或非真值，功能关闭
                  inputDescFixEnabled = false;
                } else {
                  // open 为 true，检查 key 数组
                  const keyArray = Array.isArray(config.key) ? config.key : [];

                  if (keyArray.length === 0) {
                    // key 数组为空，对所有流程生效
                    inputDescFixEnabled = true;
                  } else {
                    // key 数组不为空，只对相应流程生效
                    const currentProcessKey = store.state.config?.ProcessDefinitionKey || '';

                    if (currentProcessKey && keyArray.includes(currentProcessKey)) {
                      inputDescFixEnabled = true;
                    } else {
                      inputDescFixEnabled = false;
                    }
                  }
                }
              } catch (parseError) {
                // JSON 解析失败，降级为旧的布尔值逻辑
                console.warn('[Input] inputDescFix 配置解析失败，降级为布尔值判断', parseError);
                inputDescFixEnabled = configStr === 'true';
              }
            }

            if (inputDescFixEnabled) {
              if (field.value.description) {
                if (isInArrayTable.value) {
                  // 在数组表格中：在 extra 中添加 description
                  extraContent.push(
                    vueH('div', { class: 'formily-vant-field-desc' }, field.value.description)
                  );
                } else {
                  // 不在数组表格中：使用 newSlots.label
                  newSlots.label = () => [
                    h(
                      Cell,
                      {
                        attrs: {
                          label: field.value.description,
                          title: field.value.title,
                        },
                      },
                      {}
                    ),
                  ];
                }
              }
            } else {
              // inputDescFix 未启用：始终在 label 位置显示 description
              if (field.value.description) {
                newSlots.label = () => [
                  h(
                    Cell,
                    {
                      attrs: {
                        label: field.value.description,
                        title: field.value.title,
                      },
                    },
                    {}
                  ),
                ];
              }
            }
          } catch (e) {
          }



          return extraContent;
        };

        // newSlots.label = field.value.description
        //     ? () => [
        //       h(
        //         Cell,
        //         {
        //           attrs: {
        //             label: field.value.description,
        //             title: field.value.title,
        //           },
        //         },
        //         {}
        //       ),
        //       ]
        //     : undefined;



        return h(
          TransformVanInput,
          {
            class: {
              [`${stylePrefix}-input-asterisk`]:
                attrs.asterisk || field.value.decoratorProps.asterisk,
              ['van-field__bordered']: field.value.componentProps.bordered,

            },
            id: id,
            attrs: {
              id: id,
              ...attrs,
              ...props,
              'label-width': field.value.componentProps.mobileLabelWidth || null,
              'data-grid-span': field.value.decoratorProps.gridSpan,
              clearable: field.value.componentProps.clearable ?? false,
              autosize: true,
              type: field.value.componentType === 'TextArea' ? 'textarea' : '',
              disabled: field.value.pattern === 'disabled',
              readonly: field.value.pattern === 'readonly',
              placeholder: field.value.componentProps.placeholder || '请填写' + field.value.title,
            },
            on: listeners,
          },
          newSlots
        );
      };
    },
  })
);

export const inputValidate = mapProps(
  { validateStatus: true, title: 'label', required: true },
  (props, field) => {
    if (isVoidField(field)) return props;
    if (!field) return props;
    const takeMessage = () => {
      const split = (messages) =>
        messages.reduce((buf, text, index) => {
          if (!text) return buf;
          return index < messages.length - 1 ? buf.concat([text, ', ']) : buf.concat([text]);
        }, []);

      if (field.validating) return;
      if (props.feedbackText) return props.feedbackText;
      if (field.selfErrors.length) return split(field.selfErrors);
      if (field.selfWarnings.length) return split(field.selfWarnings);
      if (field.selfSuccesses.length) return split(field.selfSuccesses);
    };
    const errorMessages = takeMessage();
    return {
      errorMessage: resolveComponent(
        Array.isArray(errorMessages) ? errorMessages.join('') : errorMessages
      ),
      extra: props.extra || field.description,
    };
  },
  (props, field) => {
    if (isVoidField(field)) return props;
    if (!field) return props;
    return {
      feedbackStatus:
        field.validateStatus === 'validating'
          ? 'pending'
          : (Array.isArray(field.decorator) && field.decorator[1]?.feedbackStatus) ||
          field.validateStatus,
    };
  },
  (props, field) => {
    if (isVoidField(field)) return props;

    if (!field) return props;
    let asterisk = false;
    if (field.required && field.pattern !== 'readPretty') {
      asterisk = true;
    }
    if ('asterisk' in props) {
      asterisk = props.asterisk;
    }

    return {
      asterisk,
    };
  }
);

export const Input = connect(BaseInput, mapReadPretty(PreviewText.Input), inputValidate);

export default Input;
